<template>
  <div class="q-pa-md">
    <div class="q-mx-auto">
      <div class="row">
        <div
          class="col-md-8 col-12 text-subtitle2 text-bold q-py-md q-px-x"
          :class="this.$q.dark.mode === true ? '' : 'primary '"
        >
          Floorsheet as of
          <span
            v-if="this.$store.state.market.marketStatus"
            class="text-subtitle2"
          >
            (
            {{
              new Date(this.$store.state.market.asOfLive)
                .toISOString()
                .slice(0, 10)
            }}
            {{
              new Date(this.$store.state.market.asOfLive).toLocaleTimeString(
                "en-US",
                { hour12: false, hour: "2-digit", minute: "2-digit" }
              )
            }}
            )
          </span>
          <span v-else class="text-subtitle2"> ( {{ selectedDate }} ) </span>
        </div>

        <div class="col-md-4 col-12">
          <q-input
            filled
            v-model="selectedDate"
            capslock
            mask="date"
            :rules="['date']"
            class="text-bold"
          >
            <q-popup-proxy
              ref="qDateProxy"
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date
                v-model="selectedDate"
                @input="() => $refs.qDateProxy.hide()"
                @update:model-value="loadData(selectedDate)"
              />
            </q-popup-proxy>
            <q-icon
              name="event"
              class="text-grey text-h6 date-icon cursor-pointer q-pt-md"
            />
          </q-input>
        </div>
      </div>

      <q-table
        :rows="FloorSheetData"
        :columns="columns"
        :filter-method="filterFloorsheet"
        :filter="filterQuery"
        :pagination="{
          rowsPerPage: 20,
          sortBy: 'transaction',
          descending: true,
        }"
        :rows-per-page-options="[50, 100, 150, 200, 0]"
        binary-state-sort
        :class="
          $q.dark.mode === true
            ? 'table-sticky-header-column-dark'
            : 'table-sticky-header-column'
        "
      >
        <template v-slot:top-left>
          <div class="row">
            <!-- <q-input
              class="q-mr-md live-search"
              bordered
              dense
              debounce="300"
              v-model="filterTransaction"
              placeholder="Filter Transaction"
            >
            </q-input> -->
            <q-input
              class="q-mr-md live-search"
              bordered
              dense
              debounce="300"
              v-model="filterSymbol"
              placeholder="Filter Symbol"
            >
            </q-input>

            <q-input
              class="q-mr-md live-search"
              bordered
              dense
              debounce="300"
              v-model="filterBuyer"
              placeholder="Filter Buyer"
            >
            </q-input>
            <q-input
              class="q-mr-md live-search"
              bordered
              dense
              debounce="300"
              v-model="filterSeller"
              placeholder="Filter seller"
            >
            </q-input>
          </div>
        </template>

        <template v-slot:top-right>
          <div class="row">
            <q-btn
              @click="
                filterSymbol = '';
                // filterTransaction = '';
                filterBuyer = '';
                filterSeller = '';
              "
              color="dark"
              label="Clear Filters"
              flat
              dense
            >
              <q-icon name="clear" class="q-ml-md" />
            </q-btn>
          </div>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, Watch, onUnmounted } from "vue";
import { useStore } from "vuex";
import useData from "src/use/data";
import { LocalStorage, useQuasar } from "quasar";

export default {
  name: "TodayFloorSheet",

  setup(props) {
    const store = useStore();
    const { floorsheetSearchByDate, intradayFloorsheetSearchByDate } =
      useData();

    const selectedDate = ref("");

    const FloorSheetData = ref([]);

    const isMarketOn = ref(false);
    // isMarketOn.value = LocalStorage.getItem("isMarketOn");
    isMarketOn.value = store.state.market.marketStatus;
    let intervalId = null;

    const columns = [
      {
        name: "transaction",
        label: "Transaction",
        field: "transaction",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "center",
      },
      {
        name: "symbol",
        label: "Stock Symbol ",
        field: "symbol",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "center",
      },
      {
        name: "buyer",
        label: "Buyer",
        field: (row) => (!row.buyer ? "-" : row.buyer),
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "center",
      },
      {
        name: "seller",
        label: "Seller",
        field: (row) => (!row.seller ? "-" : row.seller),
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "center",
      },
      {
        name: "quantity",
        label: "Quantity",
        field: "quantity",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "center",
      },
      {
        name: "rate",
        label: "Rate",
        field: "rate",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "center",
      },
      {
        name: "amount",
        label: "Amount",
        field: "amount",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "center",
      },
    ];

    const filterSymbol = ref("");
    // const filterTransaction = ref("");
    const filterBuyer = ref("");
    const filterSeller = ref("");

    const filterQuery = computed({
      get() {
        return {
          symbol: filterSymbol.value?.toUpperCase(),
          // transaction: filterTransaction.value?.toLowerCase(),
          buyer: filterBuyer.value?.toLowerCase(),
          seller: filterSeller.value?.toLowerCase(),
        };
      },
      set(newValue) {
        filterSymbol.value = newValue.symbol;
        // filterTransaction.value = newValue.transaction;
        filterBuyer.value = newValue.buyer;
        filterSeller.value = newValue.seller;
      },
    });

    const filterFloorsheet = (rows, terms, cols, getCellValue) => {
      return rows.filter((row) => {
        return (
          (filterQuery.value.symbol === "" ||
            row.symbol.toUpperCase().includes(filterQuery.value.symbol)) &&
          // (filterQuery.value.transaction === "" ||
          //   row.transaction
          //     .toLowerCase()
          //     .includes(filterQuery.value.transaction)) &&
          (filterQuery.value.buyer === "" ||
            row.buyer?.toLowerCase() === filterQuery.value.buyer) &&
          (filterQuery.value.seller === "" ||
            row.seller?.toLowerCase() === filterQuery.value.seller)
        );
      });
    };

    function loadData(date) {
      if (isMarketOn.value) {
        if (date === store.state.market.asOfLive.split("T")[0]) {
          intradayFloorsheetSearchByDate(date.replaceAll("/", "-")).then(
            (res) => {
              FloorSheetData.value = res.data;
            }
          );
        } else {
          floorsheetSearchByDate(date.replaceAll("/", "-")).then((res) => {
            FloorSheetData.value = res.data;
          });
        }
      } else {
        floorsheetSearchByDate(date.replaceAll("/", "-")).then((res) => {
          FloorSheetData.value = res.data;
        });
      }
    }

    if (isMarketOn.value) {
      intervalId = setInterval(() => {
        if (selectedDate.value !== "") {
          loadData(selectedDate.value.replaceAll("/", "-"));
        }
      }, 20000);
    }

    onMounted(() => {
      if (isMarketOn.value) {
        selectedDate.value = store.state.market.asOfLive.split("T")[0];

        if (selectedDate.value !== "") {
          loadData(selectedDate.value);
        }
      } else {
        selectedDate.value = store.state.market.asOf;

        if (selectedDate.value !== "") {
          loadData(selectedDate.value);
        }
      }
    });

    onUnmounted(() => {
      clearInterval(intervalId);
    });

    return {
      selectedDate,
      FloorSheetData,
      columns,
      loadData,
      filterSymbol,
      // filterTransaction,
      filterBuyer,
      filterSeller,
      filterQuery,
      filterFloorsheet,
      isMarketOn,
    };
  },
};
</script>
